<template>
  <div v-if="visible && ad.imageUrl" class="vertical-ad-container">
    <div class="vertical-ad-wrap">
      <div class="ad-close-btn" @click="handleClose">×</div>
      <transition name="fade" mode="out-in">
        <a v-if="ad.linkUrl" :href="ad.linkUrl" target="_blank" :key="currentIndex">
          <img :src="ad.imageUrl" class="login-page-ad-image" alt="广告" />
        </a>
        <img v-else :src="ad.imageUrl" class="login-page-ad-image" alt="广告" :key="currentIndex" />
      </transition>
      <div v-if="ads.length > 1" class="ad-indicator">
        <span
            v-for="(item, index) in ads"
            :key="index"
            :class="['indicator-dot', { active: index === currentIndex }]"
            @click="currentIndex = index"
        ></span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import api from '@/api'

const visible = ref(true)
const ads = ref([])
const currentIndex = ref(0)
let timer = null

const ad = computed(() => ads.value[currentIndex.value] || {})

const handleClose = () => {
  visible.value = false
}

const startRotation = () => {
  if (ads.value.length > 1) {
    timer = setInterval(() => {
      currentIndex.value = (currentIndex.value + 1) % ads.value.length
    }, 5000)
  }
}

onMounted(() => {
  api.advertisement.getByPosition('login_page').then(({ data }) => {
    if (data && data.length > 0) {
      ads.value = data
      startRotation()
    }
  })
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<style scoped>
.vertical-ad-container {
  position: fixed;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  z-index: 9999;
}
.vertical-ad-wrap {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
}
.ad-close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  background: rgba(0,0,0,0.55);
  color: #fff;
  text-align: center;
  line-height: 28px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
}
.ad-close-btn:hover {
  background: #000;
}
.login-page-ad-image {
  width: 280px;
  display: block;
  aspect-ratio: 9 / 16;
  object-fit: cover;
}
.ad-indicator {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 6px;
  z-index: 2;
}
.indicator-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s;
}
.indicator-dot.active {
  background: #fff;
  transform: scale(1.2);
}
.indicator-dot:hover {
  background: rgba(255, 255, 255, 0.8);
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
@media screen and (max-width: 1050px) {
  .vertical-ad-container {
    display: none !important;
  }
}
</style>